<template>
  <ZtLink class="teaser is-default is-horizontal is-full group-link" :to="url">
    <div class="teaser-media">
      <slot name="media">
        <div
          v-blokkli-droppable:[editableConfig?.image]
          class="image aspect-4/3"
        >
          <MediaImage v-bind="media" responsive-style="column_full" />
        </div>
      </slot>
    </div>
    <div class="teaser-content">
      <h2
        v-blokkli-editable:[editableConfig?.title]
        class="title mt-0-0-tablet is-h3 text-balance"
        v-html="title"
      />
      <div
        v-blokkli-editable:[editableConfig?.tagline]
        class="subtitle is-h4 mb-0 text-balance"
        v-html="tagline"
      />
      <slot />

      <div
        v-blokkli-editable:[editableConfig?.text]
        class="teaser-text text-prose text-scheme-invert-ter"
        v-html="text"
      />
      <div
        v-blokkli-editable:[editableConfig?.linkTitle]
        class="link with-arrow mt-size-7 text-prose"
        v-html="linkTitle || $texts('teaserMore')"
      />
    </div>
  </ZtLink>
</template>

<script lang="ts" setup>
import type { TeaserProps } from './types'

defineProps<TeaserProps>()
</script>

<style lang="postcss">
.teaser.is-full {
  @apply tablet:grid;
  @screen tablet {
    grid-template-columns: 1fr 1fr;

    .teaser-media {
      grid-column: 2 / 3;
      grid-row: 1;
    }
    .teaser-content {
      grid-column: 1 / 2;
      grid-row: 1;
    }
  }

  .teaser-content {
    @apply desktop:pr-size-3;
  }

  &.has-number {
    .title:before {
      @apply block font-bold text-scheme-invert;
      @apply belowTablet:float-right belowTablet:ml-size-7;
      content: counter(count);
      counter-increment: count;
      font-size: 2.75em;
      margin-bottom: 0.1em;
      line-height: 0.75;
      margin-left: -0.008em;
      @screen widescreen {
        font-size: 3em;
      }
      @screen desktop {
        font-size: 3.5em;
      }
    }
  }
}
</style>
